<div [ngClass]="backdrop ? 'backdrop' : ''" [class.smallSize]="smallSize" [class.center-content]="!smallSize"
  [class.spinnerDiv]="!smallSize" [class.ion-padding]="!smallSize">
  <ion-spinner data-test="loading-spinner" [class.customSpinner]="smallerSpinner" [class.centered]="centered"
    [class.spinnerStyle]="!smallSize" [style.width.px]="size" [style.height.px]="smallSize ? size : null" [name]="name"
    [color]="color"></ion-spinner>
</div>